var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Bar',{style:(_vm.styles),attrs:{"id":"my-chart-bar-percentage","options":_vm.chartOptions,"data":_vm.chartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }